import React from "react";
import moment from "moment";
import alert from "../components/alerts/Alert";
import Alert from "../components/alerts/Alert";
import PoolData from "../pages/Auth/AWSConfig/PoolData";
import { Modal } from "antd";
import { FaCrown, FaRegCopy } from "react-icons/fa";
import { RiErrorWarningLine } from "react-icons/ri";
import { notify } from "./Toastify/toastify";

export const currencyFormatter = (num, percentage) => {
  return formatPrice(num);
  // if (Number(num) < 0.01) return Number(num);
  // if (Number(num) < 1) return Number(num)?.toFixed(2);
  //
  // if (percentage) {
  //   return Math.sign(num) * Math.abs(num).toFixed(2) + "%";
  // }
  // if (Math.abs(num) > 99999999) {
  //   return Math.sign(num) * (Math.abs(num) / 1000000000).toFixed(2) + "B";
  // } else if (Math.abs(num) > 999999) {
  //   return Math.sign(num) * (Math.abs(num) / 1000000).toFixed(2) + "M";
  // } else if (Math.abs(num) > 999) {
  //   return Math.sign(num) * (Math.abs(num) / 1000).toFixed(2) + "K";
  // }
  // return Math.sign(num) * Math.abs(num).toFixed(2);
};

function padTo2Digits(num) {
  return num.toString().padStart(2, "0");
}

export function formatDate(date, withHours = true) {
  const formattedDate = [
    padTo2Digits(date.getDate()),
    padTo2Digits(date.getMonth() + 1),
    date.getFullYear(),
  ].join("-");

  const dateDetails = [
    padTo2Digits(date.getHours()),
    padTo2Digits(date.getMinutes()),
    padTo2Digits(date.getSeconds()),
  ].join(":");

  if (withHours) {
    return formattedDate + " " + dateDetails;
  } else {
    return formattedDate;
  }

  // return (
  //   [
  //     date.getFullYear(),
  //     padTo2Digits(date.getMonth() + 1),
  //     padTo2Digits(date.getDate()),
  //   ].join("-") +
  //   " " +
  //   [
  //     padTo2Digits(date.getHours()),
  //     padTo2Digits(date.getMinutes()),
  //     padTo2Digits(date.getSeconds()),
  //   ].join(":")
  // );
}

export const dateString = (timestamp) => {
  if (typeof timestamp === "string") {
    return moment(timestamp).format("MMM DD, YYYY");
  }
  return moment.unix(timestamp).format("MMM DD, YYYY");
};

export const days_between = (date1, date2) => {
  if (date2 < date1) {
    return "Expired";
  }
  // The number of milliseconds in one day
  const ONE_DAY = 1000 * 60 * 60 * 24;

  // Calculate the difference in milliseconds
  const differenceMs = Math.abs(date1 - date2);

  // Convert back to days and return
  if (Math.round(differenceMs / ONE_DAY) > 1) {
    return `${Math.round(differenceMs / ONE_DAY)} days left`;
  }

  return `${Math.round(differenceMs / ONE_DAY)} day left`;
};

export const checkEmailException = (email) => {
  const reformedEmail = email.toLowerCase();
  switch (reformedEmail) {
    case "hadisematloob@yahoo.com":
      return "Hadisematloob@yahoo.com";
    case "amir.ashtari@unipd.it":
      return "Amir.ashtari@unipd.it";
    case "m.khalid.ateeq@Gmail.com":
      return "M.Khalid.Ateeq@Gmail.com";
    default:
      return reformedEmail;
  }
};

export const suggestFeatures = function (answer1, answer2, answer3, answer4) {
  if (answer1 === "") answer1 = "sit in front";
  if (answer2 === "") answer2 = "dig";
  if (answer3 === "") answer3 = "yes I am";
  if (answer4 === "") answer4 = "evaluate";

  const all = `${answer1}, ${answer2}, ${answer3}, ${answer4}`;
  const featureDict = new Map([
    [
      "sit in front, dig, yes I am, evaluate",
      ["Insight", "AI assistant", "Trade simulator"],
    ],
    [
      "sit in front, dig, yes I am, rely on reports",
      ["Insight", "AI assistant"],
    ],
    [
      "sit in front, dig, Im not, evaluate",
      ["Insight", "AI assistant", "Trade simulator"],
    ],
    ["sit in front, dig, Im not, rely on reports", ["AI assistant", "Insight"]],
    [
      "sit in front, no time for that, yes I am, evaluate",
      ["AI assistant", "Trade simulator"],
    ],
    [
      "sit in front, no time for that, yes I am, rely on reports",
      ["AI assistant"],
    ],
    [
      "sit in front, no time for that, Im not, evaluate",
      ["AI assistant", "Trade simulator"],
    ],
    [
      "sit in front, no time for that, Im not, rely on reports",
      ["AI assistant"],
    ],
    [
      "alerted, dig, yes I am, evaluate",
      ["Alert system", "Insight", "Trade simulator"],
    ],
    ["alerted, dig, yes I am, rely on reports", ["Alert system", "Insight"]],
    [
      "alerted, dig, Im not, evaluate",
      ["Alert system", "Insight", "Trade simulator"],
    ],
    ["alerted, dig, Im not, rely on reports", ["Alert system", "Insight"]],
    [
      "alerted, no time for that, yes I am, evaluate",
      ["Alert system", "AI assistant", "Trade simulator"],
    ],
    [
      "alerted, no time for that, yes I am, rely on reports",
      ["Alert system", "AI assistant"],
    ],
    [
      "alerted, no time for that, Im not, evaluate",
      ["Alert system", "AI assistant", "Trade simulator"],
    ],
    [
      "alerted, no time for that, Im not, rely on reports",
      ["Alert system", "AI assistant"],
    ],
  ]);

  if (answer3 === "yes I am") {
    for (const [key, value] of featureDict) {
      if (!value.includes("Developer API")) {
        featureDict.set(key, [...value, "Developer API"]);
      }
    }
  }

  const features = featureDict.get(all);
  if (features) {
    return features;
  } else {
    return ["Invalid input. Please try again."];
  }
};

// TODO: NOTE: this function edited based on the telegram authentication
export const clearLocalStorageAndSetLogoutTime = () => {
  let seeNotificationWarning;
  if (localStorage.getItem("seeNotificationWarning")) {
    seeNotificationWarning = localStorage.getItem("seeNotificationWarning");
  }

  // localStorage.clear();
  clearLocalStorage();
  localStorage.setItem("lastLogout", JSON.stringify(new Date()));
  localStorage.setItem("seeNotificationWarning", seeNotificationWarning);
};
export const isValidUserData = (userData) => {
  if (!userData || typeof userData !== "object") return false;
  const username = String(userData["custom:custom_username"] || "").trim();
  const email = String(
    userData.email || userData["cognito:username"] || "",
  ).trim();
  return Boolean(username && email);
};

export const isValidSession = (token, userData) =>
  Boolean(token) && isValidUserData(userData);

export const expiredTokenHandler = (message) => {
  if (localStorage.getItem("auth") === "telegram") {
    try {
      if (window.Android && typeof window.Android.onLogout === "function") {
        window.Android.onLogout();
        return;
      }
    } catch (e) {
      /* ignore */
    }
    if (window.location.pathname.includes("/telegram-authentication")) {
      return;
    }

    const telegramData = localStorage.getItem("telegramData");
    clearLocalStorageAndSetLogoutTime();
    localStorage.setItem("auth", "telegram");
    if (telegramData) {
      localStorage.setItem("telegramData", telegramData);
    }
    localStorage.removeItem("prevPath");
    window.location.replace("/telegram-authentication");
    return;
  }

  const token = JSON.parse(
    localStorage.getItem("aws-amplify-federatedInfo"),
  )?.token;

  if (!token) return;

  if (token?.startsWith("gen_bb_ddd_513_")) {
    console.log("go to login");
    clearLocalStorageAndSetLogoutTime();
    const user = PoolData.getCurrentUser();
    user?.signOut();
    window.location.reload();
  } else {
    console.log("go to refresh");
    const currentPath = window.location.pathname + window.location.search;
    localStorage.setItem("postRefreshRedirect", currentPath);
    window.location.href = "/refresh-session";
  }
};

export const checkAccountPlanHandler = (message) => {
  return Alert(null, message, "info", {
    cancel: "Close",
    defeat: {
      text: "Buy Plan",
      value: "buyPlan",
    },
  });
};

export const actionErrorHandler = (message) => {
  if (message == null || (typeof message === "string" && !message.trim())) {
    return;
  }
  return alert(null, message, "warning", {
    cancel: "Close",
  });
};

export const networkErrorHandler = () => {
  return alert("", "Please check your internet connection!", "warning", {
    cancel: "Close",
  });
};

export const timeOutErrorHandler = () => {
  return alert(
    "Oops, something went wrong.",
    "Please come back later.",
    "warning",
    {
      cancel: "Close",
    },
  );
};

export const errorHandler = (code, message, actionType, request) => {
  if (code === 504 && actionType !== "order_error") {
    return networkErrorHandler();
  }

  if (code === 450) {
    return expiredTokenHandler(message);
  }

  if (
    [
      "get_portfolio",
      "assistant/get_portfolio",
      "get_balance_chart",
      "exchange/get_balance_chart",
      "assistant/get_balance_chart",
      "get_exchange_trade_history",
      "get_exchange_trade_history_comphrensive",
      "get_asset_list",
      "get_prices",
    ].includes(request)
  ) {
    return;
  }

  if (
    (code === 401 || code === 402 || code === 403) &&
    actionType !== "order_error"
  ) {
    return checkAccountPlanHandler(message);
  }

  return actionErrorHandler(message);

  // else if (code === 454 && actionType !== "order_error") {
  //   timeOutErrorHandler();
  // }
};

export function formatAssetPrice(num) {
  const number = Number(num);
  // Check if the absolute value of the number is less than 1
  if (Math.abs(number) < 1) {
    return number.toFixed(2);
  } else {
    if (number < 1000) {
      // If the number is less than 1000, display it as is with 2 decimal places
      return number.toFixed(2);
    } else if (number < 1000000) {
      // If the number is in thousands range, convert to K and display with 2 decimal places
      return (number / 1000).toFixed(2) + "K";
    } else if (number < 1000000000) {
      // If the number is in millions range, convert to M and display with 2 decimal places
      return (number / 1000000).toFixed(2) + "M";
    } else {
      // If the number is in billions range, convert to B and display with 2 decimal places
      return (number / 1000000000).toFixed(2) + "B";
    }
  }
}

export const formatAmount = (amount) => {
  const amountNumber = parseFloat(amount);
  if (amountNumber > 0) {
    if (amountNumber > 100) {
      return formatAssetPrice(amount);
    }
    const m = -Math.floor(Math.log10(amount) + 1);
    const numberOfDigits = Math.max(0, m); // Ensure numberOfDigits is non-negative
    return amountNumber.toFixed(numberOfDigits + 2);
  } else {
    return amountNumber;
  }
};

export const formatPrice = (price) => {
  if (price === 0 || Number(price) === 0) return 0;
  // if (!price || isNaN(price)) return "-";
  if (!price) return "-";

  const value = parseFloat(price);

  if (value >= 1) {
    return value.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  } else if (value >= 0.01) {
    return value.toLocaleString("en-US", {
      minimumFractionDigits: 4,
      maximumFractionDigits: 4,
    });
  } else {
    return value.toLocaleString("en-US", {
      minimumFractionDigits: 6,
      maximumFractionDigits: 8,
    });
  }
};

export const extractNumberFromString = (str) => {
  // Use regular expression to match any number with optional decimal places
  const match = str.match(/[-+]?[0-9]*\.?[0-9]+/);

  // Check if a match is found
  if (match) {
    // Convert the matched string to a number
    return parseFloat(match[0]);
  }

  // Return NaN if no match is found
  return NaN;
};

export function formatCustomDate(inputDate, showHourMin, showSec) {
  if (showHourMin) {
    if (showSec) {
      return moment(inputDate).format("MMM DD, YYYY HH:mm:ss");
    } else {
      return moment(inputDate).format("MMM DD, YYYY HH:mm");
    }
  } else {
    return moment(inputDate).format("MMM DD, YYYY");
  }
}

// Function to reorder the array based on specific IDs
export function reorderArray(arr) {
  const ids = ["cryptocrispy", "swyftx"];
  let reorderedArray = [];

  // First, add items with specified IDs at the beginning
  ids.forEach((id) => {
    const matchingItem = arr.find((item) => item.id === id);
    if (matchingItem) {
      reorderedArray.push(matchingItem);
    }
  });

  // Then, add the remaining items
  arr.forEach((item) => {
    if (!ids.includes(item.id)) {
      reorderedArray.push(item);
    }
  });

  return reorderedArray;
}

export const refreshLimit = (percent, price, tradeType, limitType) => {
  if (tradeType === "Sell") {
    return limitType === "stopLoss"
      ? price * (1 + percent / 100)
      : price * (1 - percent / 100);
  } else {
    return limitType === "stopLoss"
      ? price * (1 - percent / 100)
      : price * (1 + percent / 100);
  }
  // return ((100 - percent) / 100) * price;
};

export const areObjectsEqual = (obj1, obj2, properties) =>
  properties.every((property) => obj1[property] === obj2[property]);

export const allItemsMatch = (
  arr1,
  arr2,
  properties = ["symbol", "subcategory", "category", "feature"],
) => {
  return arr1.every((item1) =>
    arr2.some((item2) => areObjectsEqual(item1, item2, properties)),
  );
};

export const calculateDateDifference = (targetDate, justSuffix) => {
  // Parse the target date using moment
  const targetMoment = moment(targetDate);

  // Check if the target date is in the past
  if (targetMoment.isBefore(moment(), "day")) {
    return "expired";
  }

  // Calculate the difference in days
  const daysDifference = targetMoment.diff(moment(), "days");

  // Determine the appropriate suffix for "day" or "days"
  const daySuffix = daysDifference === 1 ? "day" : "days";

  // If the returnDaySuffix parameter is true, return only the daySuffix
  if (justSuffix) {
    return daySuffix + " left";
  }

  // Construct the result string
  return `${daysDifference}`;
};

export const calcDifferenceInDays = (endDate, startDate) => {
  const start = moment(startDate, "YYYY-MM-DD HH:mm:ss");
  const end = moment(endDate, "YYYY-MM-DD HH:mm:ss");

  const differenceInDays = end.diff(start, "days");

  return `${differenceInDays} ${differenceInDays > 1 ? " days" : "day"}`;
};

export const showWarningForSellCurrencies = (okAction, sellType) => {
  const message =
    sellType === "fiat"
      ? "You're about to sell all your fiat currency. This action is irreversible. Please confirm you want to proceed."
      : "You're initiating the sale of all your crypto assets. This cannot be undone. Ensure you review this action before continuing.";

  const okText = sellType === "fiat" ? "Confirm" : "Continue";

  Modal.confirm({
    title: "Attention",
    centered: true,
    content: message,
    cancelText: "Close",
    okText,
    okButtonProps: {
      style: {
        backgroundColor: "#2b5fec",
        borderColor: "#2b5fec",
      },
    },
    onOk: () => {
      return new Promise((resolve, reject) => {
        // Call the okAction and only resolve the promise after it's done
        okAction().then(resolve).catch(reject);
      });
    },
    onCancel: () => {
      Modal.destroyAll();
    },
  });
};

export const showUpgradeModal = (okAction) => {
  Modal.confirm({
    title: "Upgrade to Enterprise Plan",
    content:
      "Heads up! This feature is part of our Enterprise plan.  Ready to upgrade?",
    centered: true,
    icon: <FaCrown size={18} color={"#daa520"} />,
    okText: "Buy Plan",
    okButtonProps: {
      style: {
        backgroundColor: "#0C4CFC",
        borderColor: "#0C4CFC",
      },
    },
    onOk: () => {
      okAction(); // Call the okAction without returning a promise
      Modal.destroyAll(); // This will close the modal immediately
    },
    onCancel() {
      Modal.destroyAll();
    },
  });
};

export const convertRoutNameToTitle = (route) => {
  if (route.includes("bot")) {
    return "Bot_and_Automation";
  }

  if (route.includes("alert-system")) {
    return "Alert_System";
  }

  if (route.includes("ai-assistant")) {
    return "AI_Assistant";
  }

  if (route.includes("integration")) {
    return "Integration";
  }

  if (route.includes("dashboard")) {
    return "Dashboard";
  }

  if (route.includes("insight")) {
    return "Insight";
  }

  return route;
};

export const formatUserData = (data) => {
  const { jwtToken: token, payload } = data;
  return {
    ...payload,
    sub: token,
    email_verified: true,
    iss: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_X8ZvlAfzE",
    origin_jti: token,
    aud: "1pf2nms2247fik73t0rsju4s9h",
    event_id: token,
    token_use: "id",
    auth_time: 1716648521,
    exp: 1716655721,
    iat: 1716648521,
    "custom:about_us": "MediaOrNews",
    jti: token,
    systemData: {},
  };
};

export const formatAIMode = {
  only_ai: "Only AI",
  only_onchain: "Only on-chain",
  only_ta: "Only technical indicator",
  only_social: "Only social",
};

export const calculateOffPrice = (
  offPercentage,
  mainPrice,
  duration,
  returnedValue,
) => {
  const durationCost = duration * mainPrice;
  const offValue = (offPercentage / 12) * duration;
  const offeredPrice = (((offPercentage / 12) * duration) / 100) * durationCost;

  if (returnedValue === "off") {
    return offValue;
  } else if (returnedValue === "offeredPrice") {
    return offeredPrice;
  } else {
    return durationCost - offeredPrice;
  }
};

export const getAllfeatures = (data) => {
  let results = [];
  for (const ctg in data) {
    const subCategories = data[ctg];
    for (const subKey in subCategories) {
      const features = subCategories[subKey];
      for (const featureKey in features) {
        const featureData = features[featureKey];
        const updatedFeatureData = {
          ...featureData,
          feature: featureData.name,
        };
        const { category, subcategory, feature, description } =
          updatedFeatureData;
        const featureString = `${category}/${subcategory}/${feature}/${description}`;

        updatedFeatureData.featureString = featureString;

        results.push(updatedFeatureData);
      }
    }
  }

  return results;
};

export function getDeviceType() {
  const userAgent = navigator.userAgent.toLowerCase();

  if (/mobile/i.test(userAgent)) {
    return "Mobile";
  }
  if (/tablet|ipad|playbook|silk/i.test(userAgent)) {
    return "Tablet";
  }
  if (/android/i.test(userAgent) && !/mobile/i.test(userAgent)) {
    return "Tablet";
  }
  return "Desktop";
}

export const isNotDesktop = () => getDeviceType() !== "Desktop";

let flashIntervalId = null;
let flashTimeoutId = null;
let flashBaseTitle = "";

export const flashTitle = (text = "🔔 New Signal!", duration = 8000) => {
  if (flashIntervalId) {
    clearInterval(flashIntervalId);
    flashIntervalId = null;
  }
  if (flashTimeoutId) {
    clearTimeout(flashTimeoutId);
    flashTimeoutId = null;
  }
  if (!flashBaseTitle) {
    flashBaseTitle = document.title || "CryptoCrispy App";
  }
  const base = flashBaseTitle;
  let showAlert = true;
  document.title = text;
  flashIntervalId = setInterval(() => {
    showAlert = !showAlert;
    document.title = showAlert ? text : base;
  }, 800);
  flashTimeoutId = setTimeout(() => {
    clearInterval(flashIntervalId);
    flashIntervalId = null;
    flashTimeoutId = null;
    if (document.title === text || document.title === base) {
      document.title = base;
    }
    flashBaseTitle = "";
  }, duration);
};

export function pageIsAway() {
  return document.hidden || document.visibilityState !== "visible" || !document.hasFocus();
}

export function askNotificationPermissionOnce() {
  if (typeof Notification === "undefined") return;
  if (Notification.permission !== "default") return;
  const ask = () => {
    if (Notification.permission === "default") {
      Notification.requestPermission();
    }
    window.removeEventListener("click", ask, true);
    window.removeEventListener("keydown", ask, true);
  };
  window.addEventListener("click", ask, true);
  window.addEventListener("keydown", ask, true);
}

function showPageNotice(title, payload) {
  const notice = new Notification(title, payload);
  notice.onclick = () => {
    window.focus();
    notice.close();
  };
}

export function showBrowserNotice(title, options = {}) {
  if (typeof Notification === "undefined") return;
  if (Notification.permission !== "granted") return;
  const icon = options.icon || `${window.location.origin}/favicon.ico`;
  const payload = {
    ...options,
    icon,
    requireInteraction: true,
    tag: "cryptocrispy-signal",
    renotify: true,
  };

  const showOnPage = () => {
    try {
      showPageNotice(title, payload);
    } catch {
      // The page constructor is unavailable in this browser.
    }
  };

  if (!("serviceWorker" in navigator)) {
    showOnPage();
    return;
  }

  navigator.serviceWorker
    .getRegistration()
    .then((registration) => {
      if (registration) return registration.showNotification(title, payload);
      showOnPage();
    })
    .catch(() => {
      showOnPage();
    });
}

const queuedNotices = [];
let noticeFlushTimer = null;

export function queueBrowserNotice(title, options = {}) {
  if (!title) return;
  queuedNotices.push({ title, body: options.body || "" });
  clearTimeout(noticeFlushTimer);
  noticeFlushTimer = setTimeout(() => {
    noticeFlushTimer = null;
    const batch = queuedNotices.splice(0, queuedNotices.length);
    if (!batch.length) return;
    const notice =
      batch.length === 1
        ? batch[0]
        : {
            title: `${batch.length} signal changes`,
            body: batch
              .slice(0, 3)
              .map((item) => item.title)
              .join(" · "),
          };
    flashTitle(notice.title);
    showBrowserNotice(notice.title, { body: notice.body });
  }, 2000);
}

export async function detectBrowser() {
  const userAgent = navigator.userAgent;

  if (
    navigator.brave &&
    typeof navigator.brave.isBrave === "function" &&
    (await navigator.brave.isBrave())
  ) {
    return "brave";
  }

  if (userAgent.includes("Edg")) return "edge";
  if (userAgent.includes("Firefox")) return "firefox";
  if (userAgent.includes("Safari") && !userAgent.includes("Chrome"))
    return "safari";
  if (userAgent.includes("Chrome")) return "chrome";

  return "other";
}

let noticeAccessPromptOpen = false;

function browserNoticeName(browser) {
  if (browser === "edge") return "Microsoft Edge";
  if (browser === "firefox") return "Firefox";
  if (browser === "brave") return "Brave";
  if (browser === "safari") return "Safari";
  return "Google Chrome";
}

function windowsNoticeSteps(appName) {
  return `Windows can hide every notice even when this site is allowed. Open Settings, then System, then Notifications. Turn Notifications on, and turn on ${appName} in the app list.`;
}

export function promptNoticeAccess({ onGranted, pathname } = {}) {
  if (typeof Notification === "undefined" || noticeAccessPromptOpen) return;
  if (pathname && String(pathname).includes("auth")) return;

  const permission = Notification.permission;
  if (permission === "granted") {
    if (localStorage.getItem("ccWindowsNoticeHint") === "on") return;
    noticeAccessPromptOpen = true;
    Modal.confirm({
      title: "Allow notices in Windows",
      content:
        "This site is allowed in the browser. If no notice appears, Windows is still blocking the browser. Open Settings → System → Notifications, turn Notifications on, and turn your browser on in the app list.",
      okText: "Windows is on",
      cancelText: "Remind me later",
      onOk: () => localStorage.setItem("ccWindowsNoticeHint", "on"),
      afterClose: () => {
        noticeAccessPromptOpen = false;
      },
    });
    return;
  }

  noticeAccessPromptOpen = true;
  if (permission === "default") {
    Modal.confirm({
      title: "Enable signal notices",
      content:
        "Allow notices for this site. Also turn on your browser in Windows under Settings → System → Notifications, or the notice never appears.",
      okText: "Enable",
      cancelText: "Not now",
      onOk: () =>
        Notification.requestPermission().then((result) => {
          if (result === "granted" && onGranted) onGranted();
        }),
      afterClose: () => {
        noticeAccessPromptOpen = false;
      },
    });
    return;
  }

  if (localStorage.getItem("seeNotificationWarning") === "true") {
    noticeAccessPromptOpen = false;
    return;
  }

  detectBrowser().then((browser) => {
    const helpLink = getHelpLink(browser);
    const appName = browserNoticeName(browser);
    Modal.warning({
      title: "Notifications are blocked",
      content: (
        <>
          <p>
            This site is blocked in the browser. Allow it from the lock icon in
            the address bar, then reload.
          </p>
          <p>{windowsNoticeSteps(appName)}</p>
          {helpLink ? (
            <a
              style={{ color: "#0c4cfc", textDecoration: "underline" }}
              href={helpLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              How to allow this site
            </a>
          ) : null}
        </>
      ),
      onOk: () => localStorage.setItem("seeNotificationWarning", "true"),
      afterClose: () => {
        noticeAccessPromptOpen = false;
      },
    });
  });
}

export function getHelpLink(browser) {
  switch (browser) {
    case "chrome":
      return "https://support.google.com/chrome/answer/3220216";
    case "firefox":
      return "https://support.mozilla.org/en-US/kb/push-notifications-firefox";
    case "safari":
      return "https://support.apple.com/guide/safari/block-pop-ups-sfri40696/18.0/mac/15.0";
    case "edge":
      return "https://support.microsoft.com/en-us/microsoft-edge/manage-website-notifications-in-microsoft-edge-0c555609-5bf2-479d-a59d-fb30a0b80b2b";
    case "brave":
      return "https://support.brave.com/hc/en-us/articles/360022806212-Push-notifications-in-Brave";
    default:
      return null;
  }
}

export const getSignalTypePercentages = (data, sources, liveData) => {
  let buyCount = 0;
  let sellCount = 0;
  let holdCount = 0;

  // Filter out "coin" from the sources
  const signalSources = sources?.filter((s) => s !== "coin");
  // console.log(data);
  let total = 0;

  // Iterate through the sources and count the suggestions
  signalSources.forEach((s) => {
    const signalData = data?.[0]?.[s];
    const action = signalData?.suggestion; // Access the suggestion field for the current source

    // check the signal has data and then increase total amount
    if (action) total++;

    if (action === "Buy") {
      buyCount += 1; // Increment buyCount
    } else if (action === "Sell") {
      sellCount += 1; // Increment sellCount
    } else if (action === "Hold") {
      holdCount += 1; // Increment holdCount
    }
  });

  if (liveData) {
    const { prediction } = liveData;
    total += 1;
    if (prediction === "Buy") {
      buyCount += 1;
    } else if (prediction === "Sell") {
      sellCount += 1;
    } else if (prediction === "Hold") {
      holdCount += 1;
    }
  }

  return {
    buy: (buyCount / total) * 100 || 0, // Calculate buy percentage
    sell: (sellCount / total) * 100 || 0, // Calculate sell percentage
    hold: (holdCount / total) * 100 || 0, // Calculate hold percentage
  };
};

export function getCacheData() {
  const exchangesWithCoins =
    JSON.parse(localStorage.getItem("exchangesWithCoins")) || [];
  const coinCategories =
    JSON.parse(localStorage.getItem("coinCategories")) || [];

  return [
    { key: "coinCategories", value: coinCategories },
    { key: "exchangesWithCoins", value: exchangesWithCoins },
  ];
}

export function saveCacheData(data = []) {
  data.forEach((item) => {
    localStorage.setItem(item?.key, JSON.stringify(item?.value));
  });
}

export function clearLocalStorage() {
  const cacheData = getCacheData();
  localStorage.clear();
  saveCacheData(cacheData);
}

function sortObjectKeys(obj) {
  return Object.keys(obj)
    .sort()
    .reduce((acc, key) => {
      acc[key] = obj[key];
      return acc;
    }, {});
}

function normalizeArray(arr) {
  return arr.map((item) => sortObjectKeys(item));
}

export function arraysAreEqual(a, b) {
  if (a.length !== b.length) return false;

  const normA = normalizeArray(a)
    .map((o) => JSON.stringify(o))
    .sort();
  const normB = normalizeArray(b)
    .map((o) => JSON.stringify(o))
    .sort();

  return JSON.stringify(normA) === JSON.stringify(normB);
}
